export const elementResizeLockedKey = "axisLock";